import { Injectable } from "@angular/core";
import { catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Branche } from "./branche.interface";

@Injectable()
export class BrancheService {

    baseUrl = environment.settings_url + '/branches';
    private _myBranche: ReplaySubject<Branche> = new ReplaySubject<Branche>(1);
    private _branche: ReplaySubject<Branche> = new ReplaySubject<Branche>(1);
    private _branches: ReplaySubject<Branche[]> = new ReplaySubject<Branche[]>(1);
        
    set myBranche(value: Branche) {
        this._myBranche.next(value);
    }

    get myBranche$() {
        return this._myBranche.asObservable();
    }

    set branche(value: Branche) {
        this._branche.next(value);
    }

    get branche$() {
        return this._branche.asObservable();
    }

    set branches(value: Branche[]) {
        this._branches.next(value);
    }

    get branches$() {
        return this._branches.asObservable();
    }

    constructor(
        private _httpClient: HttpClient
    ) { }

    create(branche: Branche): Observable<Branche> {
        return this._httpClient.post<Branche>(`${this.baseUrl}`, branche)
        .pipe(
            tap((branche) => {
                this.branche = branche;
                return (branche);
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    getBranche(id: string): Observable<Branche> {
        return this._httpClient.get<Branche>(`${this.baseUrl}/${id}`)
        .pipe(
            tap((branche) => {
                this.branche = branche;
                return (branche);
            }),
            catchError((error) => {
                throw new Error(error);
            })        
        );
    }

    getBranchesAll(): Observable<Branche[]> {
        return this._httpClient.get<Branche[]>(`${this.baseUrl}`)
        .pipe(
            tap((branches) => {
                this.branches = branches;
                return (branches);
            }),
            catchError(() => of([] as Branche[]))
        );
    }

    loadBranches(): void {
        this.getBranchesAll().subscribe();
    }
}